export default {
  name: 'LoadingDot'
};
